import * as Actions from '../actions/auth'
import authService from '@/services/auth.service'

const state = {
  accessToken: localStorage.getItem('accessToken') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
  clientToken: localStorage.getItem('clientToken') || null,
  tokenExtensions: JSON.parse(localStorage.getItem('tokenExtensions')) || '',
  authStatus: '',
  tokenType: localStorage.getItem('tokenType') || '',
  forgotPasswordStatus: '',
  changePasswordStatus: '',
  acceptTermsAndConditionsStatus: '',
  termsAndConditionsAcceptanceRequired: JSON.parse(localStorage.getItem('termsAndConditionsAcceptanceRequired')) || false,
  password: null,
  requiresTwoFactorAuthentication: JSON.parse(localStorage.getItem('requiresTwoFactorAuthentication')) || false,
  passwordRotationRequired: JSON.parse(localStorage.getItem('passwordRotationRequired')) ||   false,
  passwordRotationUpdated: JSON.parse(localStorage.getItem('passwordRotationUpdated')) || false,
  twoFactorAuthenticationMethods:'EMAIL_VERIFICATION',
  isAuthenticated: JSON.parse(localStorage.getItem('isAuthenticated')) || false,
  guest: localStorage.getItem('isGuest') || false,
  isTwoFactorAuthenticated: JSON.parse(localStorage.getItem('isTwoFactorAuthenticated')) || false
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  authStatus: state => state.authStatus,
  tokenExtensions: state => state.tokenExtensions,
  isTermsAndConditionsAcceptanceRequired: state => !!state.termsAndConditionsAcceptanceRequired,
  accessToken: (state) => state.accessToken,
  tokenType: (state) => state.tokenType,
  refreshToken: state => state.refreshToken,
  changePasswordStatus: state => state.changePasswordStatus,
  requiresTwoFactorAuthentication: state => state.requiresTwoFactorAuthentication,
  passwordRotationRequired: state =>  state.passwordRotationRequired,
  passwordRotationUpdated: state => state.passwordRotationUpdated,
  twoFactorAuthenticationMethods: state => state.twoFactorAuthenticationMethods,
  hasValidTwoFactorVerification: state => state.isTwoFactorAuthenticated,
  isGuest: state => state.guest,
  clientToken: state => state.clientToken
}

const actions = {
  [Actions.AUTH_REQUEST]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(Actions.AUTH_REQUEST)
      authService.getInternalToken(user)
        .then(resp => {
          localStorage.setItem('accessToken', resp.accessToken)
          localStorage.setItem('refreshToken', resp.refreshToken)
          localStorage.setItem('tokenType', resp.tokenType)
          localStorage.setItem('tokenExtensions', JSON.stringify(resp.extensions))
          commit(Actions.SET_GUEST, false)
          commit(Actions.AUTH_SET_ACCESS_TOKEN, resp)

          if (resp.termsAndConditionsAcceptanceRequired) {
            localStorage.setItem('termsAndConditionsAcceptanceRequired', true)
            commit(Actions.TERMS_AND_CONDITIONS_REQUIRED, resp)
          }
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.AUTH_ERROR, err)
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('tokenExtensions')
          reject(err)
        })
    })
  },
  [Actions.AUTH_SUCCESS]:({ commit,payload }) =>{
    commit(Actions.AUTH_SUCCESS,payload)
  },
  [Actions.AUTH_SEND_EMAIL_CONFIGURATION_CODE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      authService.sendEmailVerificatinCode(payload)
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  [Actions.AUTH_VALIDATE_TWO_FACTOR_AUTHENTICATION_CODE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      authService.validatingEmailVerificatinCode(payload)
        .then(resp => {

          if(resp.status===204){
            commit(Actions.AUTH_TWO_FACTOR_AUTHENTICATION_SUCCESS)
            commit(Actions.AUTH_SUCCESS)
          }
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.AUTH_ERROR, err)
          reject(err)
        })
    })
  },
  [Actions.AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(Actions.AUTH_LOGOUT)
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('tokenExtensions')
      localStorage.removeItem('clientToken')
      resolve()
    })
  },
  [Actions.CLIENT_TOKEN_REQUEST]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      authService.getClientToken()
        .then(resp => {
          localStorage.setItem('clientToken', resp.accessToken)
          commit(Actions.CLIENT_TOKEN_SUCCESS, resp)
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.CLIENT_TOKEN_ERROR, err)
          localStorage.removeItem('clientToken')
          reject(err)
        })
    })
  },
  [Actions.FORGOT_PASSWORD_REQUEST]: ({ commit }, email) => {
    return new Promise((resolve, reject) => {
      commit(Actions.FORGOT_PASSWORD_REQUEST)
      authService.requestPasswordChange(email)
        .then(resp => {
          commit(Actions.FORGOT_PASSWORD_SUCCESS, resp)
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.FORGOT_PASSWORD_ERROR, err)
          reject(err)
        })
    })
  },
  [Actions.CHANGE_PASSWORD_REQUEST]: ({ commit }, request) => {
    return new Promise((resolve, reject) => {

      commit(Actions.CHANGE_PASSWORD_REQUEST)
      authService.changePassword(request.password, request.token)
        .then(resp => {
          commit(Actions.CHANGE_PASSWORD_SUCCESS, resp)
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.CHANGE_PASSWORD_ERROR, err)
          reject(err)
        })
    })
  },
  [Actions.TERMS_AND_CONDITIONS_REQUEST]: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit(Actions.TERMS_AND_CONDITIONS_REQUEST)
      authService.acceptTermsAndConditions(user)
        .then(resp => {
          localStorage.setItem('accessToken', resp.accessToken)
          localStorage.setItem('refreshToken', resp.refreshToken)
          localStorage.setItem('tokenExtensions', JSON.stringify(resp.extensions))
          resolve(resp)
        })
        .catch(err => {
          commit(Actions.TERMS_AND_CONDITIONS_ERROR, err)
          reject(err)
        })
    })
  },
  [Actions.PASSWORD_ROTATION_UPDATED]: ({ commit }) => {
   localStorage.setItem('passwordRotationUpdated', true)
   commit(Actions.PASSWORD_ROTATION_UPDATED)
  },
  [Actions.SET_GUEST]: ({ commit }, payload) => {
    commit(Actions.SET_GUEST, payload)
  }
}

const mutations = {
  [Actions.AUTH_REQUEST]: (state) => {
    state.authStatus = 'loading';
  },
  [Actions.AUTH_SUCCESS]: (state) => {
    localStorage.setItem('isAuthenticated', 'true')
    state.isAuthenticated = JSON.parse(localStorage.getItem('isAuthenticated')) || false
  },
  [Actions.AUTH_SET_ACCESS_TOKEN]:(state, parameters) => {
    state.accessToken = parameters.accessToken
    state.refreshToken = parameters.refreshToken
    state.tokenType = parameters.tokenType
    state.tokenExtensions = parameters.extensions
    localStorage.setItem('requiresTwoFactorAuthentication', parameters.tfaRequired )
    localStorage.setItem('passwordRotationRequired', parameters.passwordRotationRequired)
    state.requiresTwoFactorAuthentication = JSON.parse(localStorage.getItem('requiresTwoFactorAuthentication')) || false 
    state.twoFactorAuthenticationMethods = 'EMAIL_VERIFICATION'
  },
  [Actions.AUTH_ERROR]: state => {
    state.authStatus = 'error'
  },
  [Actions.AUTH_TWO_FACTOR_AUTHENTICATION_SUCCESS]: state => {
    localStorage.setItem('isTwoFactorAuthenticated', 'true')
    state.isTwoFactorAuthenticated = JSON.parse(localStorage.getItem('isTwoFactorAuthenticated')) || false
  },
  [Actions.AUTH_LOGOUT]: state => {
    state.accessToken = ''
    state.refreshToken = ''
    state.tokenExtensions = ''
    state.termsAndConditionsAcceptanceRequired = false
    state.doctorInformation = ''
     state.requiresTwoFactorAuthentication = false
    state.twoFactorAuthenticationMethods = ''
    state.isAuthenticated = false
    state.isTwoFactorAuthenticated = false
    state.passwordRotationUpdated = false
    state.passwordRotationRequired = false
    state.clientToken = null
    localStorage.removeItem('clientToken')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('tokenExtensions')
    localStorage.removeItem('termsAndConditionsAcceptanceRequired')
    localStorage.removeItem('doctorInformation')
    localStorage.removeItem('requiresTwoFactorAuthentication')
    localStorage.removeItem('passwordRotationRequired')
    localStorage.removeItem('passwordRotationUpdated')
    localStorage.removeItem('isTwoFactorAuthenticated')
    localStorage.removeItem('isAuthenticated')
    localStorage.removeItem('isGuest')
  },
  [Actions.CLIENT_TOKEN_SUCCESS]: (state, parameters) => {
    state.clientToken = parameters.accessToken
  },
  [Actions.CLIENT_TOKEN_ERROR]: state => {
    state.clientToken = null
  },
  [Actions.FORGOT_PASSWORD_REQUEST]: (state) => {
    state.forgotPasswordStatus = 'loading'
  },
  [Actions.FORGOT_PASSWORD_SUCCESS]: (state) => {
    localStorage.removeItem('clientToken')
    state.clientToken = null
    state.forgotPasswordStatus = 'success'
  },
  [Actions.FORGOT_PASSWORD_ERROR]: state => {
    localStorage.removeItem('clientToken')
    state.clientToken = null
    state.forgotPasswordStatus = 'error'
  },
  [Actions.CHANGE_PASSWORD_REQUEST]: (state) => {
    state.changePasswordStatus = 'loading'
  },
  [Actions.CHANGE_PASSWORD_SUCCESS]: (state) => {
    state.changePasswordStatus = 'success'
  },
  [Actions.CHANGE_PASSWORD_ERROR]: state => {
    state.changePasswordStatus = 'error'
  },
  [Actions.RESET_CHANGE_PASSWORD_STATUS]: state => {
    state.changePasswordStatus = ''
  },
  [Actions.TERMS_AND_CONDITIONS_REQUIRED]: (state) => {
    state.termsAndConditionsAcceptanceRequired = true
  },
  [Actions.TERMS_AND_CONDITIONS_REQUEST]: (state) => {
    state.acceptTermsAndConditionsStatus = 'loading'
  },
  [Actions.TERMS_AND_CONDITIONS_SUCCESS]: (state, parameters) => {
    state.acceptTermsAndConditionsStatus = 'success'
    state.termsAndConditionsAcceptanceRequired = false
    state.accessToken = parameters.accessToken
    state.refreshToken = parameters.refreshToken
    state.tokenType = parameters.tokenType
    state.tokenExtensions = parameters.extensions
    localStorage.removeItem('termsAndConditionsAcceptanceRequired')
  },
  [Actions.TERMS_AND_CONDITIONS_ERROR]: state => {
    state.acceptTermsAndConditionsStatus = 'error'
  },
  [Actions.SET_TOKEN](state, parameters) {
    const { accessToken } = parameters
    Object.assign(state, { ...state, accessToken })
  },
  [Actions.PASSWORD_ROTATION_UPDATED] : state => {
    state.passwordRotationUpdated = true
  },
  [Actions.SET_GUEST](state, payload) {
    state.guest = payload
    localStorage.setItem('isGuest', payload)
  }
}

export default {
  actions,
  getters,
  mutations,
  state
}
